export default {
  title: {
    companyListTitle: '公司列表',
    companyDetailTitle: '公司详情',
    editCompanyTitle: '编辑公司',
    premiumManagementTitle: '收费设置'
  },
  menu: {
    companyListMenu: '公司列表',
    companyDetailMenu: '公司详情',
    editCompanyMenu: '编辑公司',
    premiumManagementMenu: '收费设置'
  },
  label: {
    all: '全部',
    pending: '待定',
    new: '新注册',
    rejected: '已拒绝',
    approved: '已审核',
    closed: '已关闭',
    reject: '拒绝',
    approve: '同意',
    close: '关闭',
    withinOneMonth: '1个月内',
    withinTwoMonth: '2个月内',
    companyName: '公司名称',
    registeredDate: '注册日期',
    status: '状态',
    expirationDate: '过期时间',
    functions: '功能',
    companyStatusTip: '你确定将公司状态改为“{status}”？',
    purgeDataTip: '你确定清除所有求职者数据？',
    view: '查看',
    onWeb: '网页版',
    onApp: '手机应用',
    basicInfo: '基础信息',
    companyDescription: '公司描述',
    contactInformation: '联系人信息',
    contactPerson: '联系人姓名',
    contactPhone: '联系人电话',
    companyWebsite: '公司网址',
    companyCreator: '公司创建人',
    companyCreatorEmail: '公司创建人邮箱',
    businessLicense: '营业执照',
    businessLicenseNumber: '营业执照编号',
    businessLicenseWithColon: '营业执照',
    companyChineseDisplayName: '公司中文显示名称',
    companyEnglishDisplayName: '公司英文显示名称',
    companyChineseRegisteredName: '公司中文注册名',
    companyEnglishRegisteredName: '公司英文注册名',
    contactPersonName: '联系人姓名',
    contactPersonMobileNumber: '联系人手机号码',
    companyType: '公司类型',
    industry: '行业',
    yearFoundedInGreaterChina: '在大中华成立年份',
    employeesInGreaterChina: '大中华员工',
    location: '所在地',
    countryOrRegion: '国家 / 地区',
    numberOfLocationsOrBranchesInChina: '办事处数量',
    provinceOrState: '省 / 州',
    cityOrTown: '城市 / 城镇',
    logo: '公司标志',
    logoTip: '（建议上传{width}X{height}的jpg或png格式的图片）',
    licenseNumber: '营业执照编号',
    licenseTip: '（如营业执照正在申办，需上传相关负责人身份证原件照片或复印件，我们会尽快联系您，更新并完善您公司的相关证照信息。）',
    address: '注册地址',
    website: '公司网站',
    attractiveWords: '公关文字',
    companyChineseDescription: '公司描述（中文）',
    companyEnglishDescription: '公司描述（英文）',
    public: '公开',
    yes: '是',
    no: '否',
    emailSuffix: '公司邮箱域名',
    emailSuffixExample: '(输入公司邮箱的域名，例如：如果您的公司邮箱为abc@def.com，那么对应的公司邮箱域名为def.com)',
    privacy: '新申请者隐私设置',
    privacySettingOpenTitle: '开放模式 - 该模式适用于急于寻找工作的求职者',
    privacySettingOpenContent: '允许任何菁客的会员招聘企业查看您的档案包括个人简历及测评结果。通常应届毕业生或者急于寻找工作的求职者会将自己的档案模式设置成“开放模式”。',
    privacySettingSemiOpenTitle: '部分开放模式 - 该模式适用于不急于马上换工作，但仍希望在市场上寻找合适机会的求职者',
    privacySettingSemiOpenContent: '允许任何菁客的会员招聘企业查看您的部分档案,除个人身份信息外。通常求职者在已有工作的状态下若仍然希望通过保密的方式寻求其他就业机会，便会将自己的档案设置为“部分开放模式”。该模式下不开放您的身份信息（姓名）和联系信息。开放的部分档案只包括对您与就业机会进行匹配所需的必要信息，包括您的职称、工作经验以及所学专业等等。在此模式下, 您仍然可以通过申请某公司职位或者关注某公司将您的档案信息全部开放给这个公司。',
    privacySettingPrivateTitle: '隐私 - 该模式适用于已找到工作，不打算在市场上寻找机会的求职者',
    privacySettingPrivateContent: '在隐私模式下，所有菁客会员招聘企业都不能查看您的任何信息(除非您之前已申请某公司职位或者关注某公司, 您的档案信息将仅开放给这个公司)。通常那些不再打算找工作的求职者会将他们的档案设置为“隐私模式”。请您注意，当某一会员招聘企业更新其系统而显示您已经被其雇佣时，您的档案将自动设置成“隐私模式”。您可以在任何时候手动调整这一模式。',
    candidateStatus: '求职者状态管理',
    candidateStatusCnName: '求职者状态中文名称',
    candidateStatusEnName: '求职者状态英文名称',
    validOrganization: '请注意，如果没有一个有效的营业执照编号、经营许可证和注册地址，您的公司帐户将不会通过审核。',
    companyListAdsFirstLevel: '第一层级',
    companyListAdsSecondLevel: '第二层级',
    companyListAdsThirdLevel: '第三层级',
    hmReviewingSystem: '招聘经理初选筛查系统',
    interviewSchedulingSystem: '面试安排系统',
    quicklyCreateTeamsMeeting: '快速创建Teams会议',
    viewHmAvailability: '获取招聘经理忙闲时间',
    referralTypeRegular: '正常',
    referralTypeLite: '精简',
    employeeIndependency: '员工独立',
    employeeSharing: '员工共享',
    allowEmployeeApplyJob: '允许员工申请',
    pointsRewords: '积分奖励',
    primaryAdsImage: '主广告位图片',
    subAdsImage: '副广告位图片',
    adsImageTip: '（建议上传980X300的jpg或png格式的图片）',
    adsLink: '广告位链接',
    adsLinkExample: '(比如: https://www.ajinga.com/)',
    settingEmail: '设置邮箱',
    settingChannel: '选择渠道',
    companyLevel: '公司级别',
    jobLevel: '职位级别',
    settingColor: '设置颜色',
    hiddenWebPageBottomStatement: "隐藏 'Powered by ajinga.com'",
    agencyJustShow: '上传后候选人联系方式直接显示',
    periodicity: '周期',
    day: '天',
    jobPosterImage: '图片海报',
    jobPosterVideo: '视频海报',
    ambassadorPoster: '开启宣传大使功能',
    satisfactionSurveyCandidate: '求职者',
    satisfactionSurveyHm: '招聘经理',
    candidateConfirmToDelete: '求职者确认后删除',
    candidateConfirmToDeleteTip: '如果未确认则保留于人才库',
    candidateConfirmToStay: '求职者确认后保留',
    candidateConfirmToStayTip: '如果未确认则会被自动从人才库中删除',
    deleteDirectly: '直接删除',
    resetAllExpireDate: '一键设置时间',
    viewCompanyUserList: '查看所有用户账户',
    premiumSettingTip: '收费设置',
    sendInterviewSMS: '面试短信',
    automatedScheduler: '自动面试安排',
    parseResumeTag: '候选人画像',
    autoPostJob: '自动发布',
    manualPostJob: '手动发布',
    smsSend: '短信服务'
  },
  premiumType: {
    hierarchy: '层级显示',
    vendor_management: '猎头供应商管理',
    candidate_upload: '添加求职者',
    status_cause_management: '求职者状态管理',
    birthday_notice: '生日提醒',
    'rate-management': '面试管理',
    receive_resume_email: '邮箱接收简历',
    duplicate_candidate: '重复候选人提示',
    satisfaction_survey: '满意度调查',
    video_navigation: '品牌视频导览',
    submit_resume: '推荐人提交候选人',
    rpa_job_posting: '职位自动化发布',
    assessments: '系统评测',
    open_api_management: '开放接口管理',
    copy_candidate: '复制求职者',
    data_purge: '求职者个人信息自动删除',
    export_data: '导出数据',
    post_applicant: '体验门户',
    application_form: '应聘登记表',
    resume_match: '人岗匹配',
    custom_mobile_landing_page: '定制公司主页',
    alumni_management: '前员工管理',
    referral: '推荐',
    post_job: '职位发布',
    auto_post_job: '自动发布',
    manual_post_job: '手动发布',
    custom_email: '自定义消息模板',
    sms_send: '短信服务',
    consent_sms_send: '协议同意短信',
    other_sms_send: '其他短信（面试，AI面试，三方测评，生日提醒）',
    applicant_lock: '候选人锁定/状态逻辑',
    user_num: '用户数量',
    upload_video: '视频问卷',
    job_poster: '职位海报',
    job_num: '职位数量',
    onboarding: '入职报到',
    job_board_point_dashboard: '招聘网站点数管理',
    re_apply: '重复申请',
    job_custom_field: '职位自定义字段',
    company_expire: '公司账户',
    candidate_relationship_management: '求职者关系管理',
    soft_user: '潜在候选人',
    color_customization: '样式定制',
    hr_dashboard: '招聘人员看板',
    wechat_template_message: '微信模板消息',
    company_list_level: '工作列表广告位层级',
    custom_job_detail: '定制职位详情页',
    upload_portfolio: '附件问卷',
    rpa_management: 'RPA管理',
    chatbot_prescreen_survey_management: '申请人前置问卷',
    candidate_search: '人才搜索',
    ai_summary: 'AI简历提炼',
    non_consent_candidate_change_status_logic: '未同意协议候选人状态逻辑',
    ai_resume_match: 'AI匹配度',
    boss_application_forwarding: 'Boss申请转发',
    microsite_campaign_management: '微网站和活动管理',
    tag_management: '标签管理',
    preference_survey_management: '偏好问卷管理',
    crm_parse_resume_sdk_tag: '候选人画像',
    ai_comparison: 'AI比较',
    ai_talent_recommended: 'AI人才推荐',
    offer_management: 'Offer管理',
    hr_report: 'BI报表',
    ai_interview: 'AI面试',
    candidate_status_update_notification_internal: '候选人状态更新通知（内部）',
    similar_candidate: 'AI人才镜像',
    ai_chat_search: 'AI聊天搜索',
    ai_resume_parse: 'AI简历解析',
    ai_candidate_search_filter: 'AI候选人筛选器',
    ai_chatbot: 'AI聊天机器人'
  },
  premiumCategories: {
    basic_config: '基础配置',
    recruiting_config: '招聘配置',
    career_brand_config: '雇主品牌配置',
    referral_config: '推荐配置',
    interview_config: '面试配置',
    crm_config: 'CRM配置',
    onboarding_config: '入职配置',
    data_config: '数据配置',
    ai_config: 'AI配置'
  },
  btn: {
    upload: '上传',
    premiumSetup: '收费设置',
    pending: '待定',
    new: '新注册',
    rejected: '拒绝',
    approved: '同意',
    closed: '关闭',
    assign: '求职者状态分配',
    continue: '继续',
    register: '注册'
  },
  placeholder: {
    inputCompanyName: '通过公司名称搜索',
    emailSuffixPlaceholder: 'e.g. def.com',
    keywords: '关键字所搜',
    selectDate: '请选择日期'
  },
  message: {
    expireDateError: '收费项：{name} 的到期日期不能为空',
    wrongNumberFormat: '收费项：{name} 的格式不正确',
    wrongPhotoFileType: '请上传{imageType}格式图片',
    resetExpireDateSuccess: '设置成功！',
    emailSuffixError: '含有不合法的字符，输入内容只能是字母、数字、"."和"-"'
  }
}
